import { COLORS } from './utils'

export const MODAL_STYLES = {
  paper: {
    borderRadius: 2,
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 8px 24px, rgba(0, 0, 0, 0.05) 0px 2px 6px',
    backgroundImage: COLORS.background.gradient,
    maxHeight: '90vh',
    maxWidth: '800px !important'
  },
  fieldWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 0.75,
    '& .MuiFormControl-root': {
      flex: 1
    }
  },
  input: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 1,
      backgroundColor: COLORS.background.card,
      '&:hover': {
        backgroundColor: COLORS.background.hover
      },
      '&.Mui-focused': {
        backgroundColor: COLORS.background.card,
        boxShadow: 'rgba(0, 0, 0, 0.05) 0px 2px 4px'
      },
      padding: '0 !important'
    },
    '& .MuiInputLabel-root': {
      fontSize: '0.9rem'
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 14px'
    },
    '& .MuiOutlinedInput-multiline': {
      padding: '0 !important',
      '& > div': {
        padding: '0 !important'
      },
      '& fieldset': {
        padding: '0 !important'
      },
      '& textarea': {
        padding: '12px 14px !important'
      }
    }
  },
  helpIcon: {
    width: 22,
    height: 22,
    color: 'text.secondary',
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    borderRadius: '50%',
    flexShrink: 0,
    mt: 0.75,
    '&:hover': {
      color: 'primary.main',
      backgroundColor: 'rgba(33, 150, 243, 0.08)'
    }
  }
} 